<template>
  <div class="container">
    <div class="title">{{ $t('c2c').chat }}</div>
    <div class="info">
      <!-- 顶部 -->
      <div class="top">
        <!-- tab切换 -->
        <div class="tabs"><span v-for="(item, index) in tabs" :key="`tab${index}`" :class="active == item.value ? 'active' : ''" @click="changeTab(item.value)">{{ item.name }}</span></div>
      </div>
      <!-- 列表 -->
      <div class="orderList">
        <van-list v-model="loading" :finished="finished" :loading-text="$t('public').loadingText" @load="getOrderList" :immediate-check="false">
          <div class="item" v-for="(dItem, dIndex) in oList" :key="`chat${dIndex}`" @click="$router.push({ name: 'Chat', query: { id: dItem.ctcOrderId } })">
            <div class="logo">{{ dItem.vendorName.substring(0, 1) }}</div>
            <div class="right">
              <!-- 名称 -->
              <div class="name"><span>{{ dItem.vendorName }}</span> {{ dItem.talkCreateTime | getLocalTime }}</div>
              <!-- 内容 -->
              <div class="txt">{{ dItem.talkContentType == 1 ? dItem.talkContent : dItem.talkContentType == 2 ?
                $t('c2c').picture :
                '' }}</div>
            </div>
          </div>
        </van-list>
      </div>
    </div>
  </div>
</template>

<script>
import chatApi from '@/api/chat'

export default {
  data() {
    return {
      active: "",
      isRun: false,
      loading: false,
      finished: false,
      parms: {
        pageNum: 1,
        pageSize: 15,
      },
      oList: [],
    }
  },
  computed: {
    tabs() {
      return [{
        "name": this.$t('c2c').all,
        "value": ""
      }, {
        "name": this.$t('c2c').inprogress,
        "value": "1"
      },
      ]
    },
  },
  mounted() {
    window.scrollTo(0, 0);
    this.getOrderList()
  },
  methods: {
    //切换
    changeTab(val) {
      this.active = val
      this.refreshOrderList()
    },
    //刷新获取订单列表
    refreshOrderList() {
      this.oList = []
      this.parms.pageNum = 1
      this.finished = false;
      this.getOrderList()
    },
    // 获取订单列表
    async getOrderList() {
      if (this.isRun) return
      this.isRun = true
      this.parms.status = this.active
      const res = await chatApi.getTalkItemGroupList(this.parms)
      this.oList.push(...res.rows);
      this.isRun = false
      this.parms.pageNum++
      // 加载状态结束
      this.loading = false;
      // 数据全部加载完成
      if (this.oList.length >= res.total)
        this.finished = true;
    },
  }
}
</script>

<style lang="less" scoped>
.container {
  min-height: 100vh;
  padding-top: 110px;
  padding-bottom: 80px;
  width: 100%;
  background: var(--background_color);

  .title {
    font-size: 36px;
    font-weight: bold;
    color: var(--text_color);
    margin: 0 auto;
    max-width: 1280px;
    padding-bottom: 40px;
  }

  .info {
    margin: 0 auto;
    max-width: 1280px;

    .top {
      width: 100%;
      background: var(--background_color);

      .tabs {
        font-size: 16px;
        color: var(--ntext_color);
        border-bottom: 1px solid var(--info_color);
        display: flex;
        align-items: center;

        span {
          padding: 12px 0;
          margin-right: 50px;
        }

        .active {
          color: var(--primary_color);
          font-weight: bold;
          padding-bottom: 10px;
          border-bottom: 2px solid var(--primary_color);
        }
      }
    }

    .orderList {
      margin-bottom: 30px;

      .item {
        padding: 20px 15px;
        color: var(--text_color);
        font-size: 15px;
        border-bottom: 1px solid var(--info_color);
        display: flex;
        align-items: center;
        justify-content: space-between;

        &:hover {
          background: var(--info_color);
        }

        .logo {
          font-size: 16px;
          width: 30px;
          height: 30px;
          background: var(--text_color);
          color: var(--background_color);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .right {
          margin-left: 10px;
          width: 1200px;

          .name {
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-size: 13px;
            color: var(--ntext_color);

            span {
              max-width: 1000px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              font-size: 15px;
              color: var(--text_color);
            }
          }

          .txt {
            margin-top: 5px;
            max-width: 1200px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            font-size: 13px;
            color: var(--ntext_color);
          }
        }
      }
    }
  }
}
</style>
